import React from 'react';

import { atom } from 'recoil';

/* 仮予約データ */
// TODO インポートした型に追記できるか調査
type RentalPriceListType = {
  __typename: 'rentalPriceListType';
  rentalPrice?: number | null;
  rentalPriceDivision?: string | null;
};
type EquipmentListInput = {
  equipmentId?: string;
  number: number;
  category?: string | null;
  categoryName?: string | null;
  equipmentImagePath?: string | null;
  equipmentName?: string | null;
  fullFlag?: boolean | null;
  rentalPriceList?: Array<RentalPriceListType | null> | null;
  num: number;
  unitPrice: number;
};
type Reservation = {
  reservationId: string;
  facilityId: string;
  areaId: string;
  sectionIdList: string[];
  sectionNameList: string[];
  adminFlag: boolean;
  groupId: string;
  reservedStartTime: string;
  reservedEndTime: string;
  usagePurpose: string;
  usageType: string;
  usageDetails: string;
  usageRange: string;
  personInCharge: string;
  email: string;
  tel: string;
  usageContents: string;
  numberOfTotalPeople: number;
  numberOfElementaryMiddleSchoolStudents: number;
  numberOfElementaryHighSchoolStudents: number;
  numberOfOrdinaryPerson: number;
  numberOfSpectator: number;
  isCollectFee: boolean;
  isCommercialActivity: boolean;
  isElectricityUtilization: boolean;
  electricityUtilizationStartTime: string;
  electricityUtilizationEndTime: string;
  equipmentList?: EquipmentListInput[];
  totalFee: number;
  facilityFee: number;
  equipmentFee?: number;
  paymentMethodsFlag: string;
  selectedEquipmentTotal: number;
  selectedEquipmentCount: number;
  groupName: string;
  areaName: string;
  depositDate: string;
};

const ReservationState = atom<Reservation>({
  key: 'reservationState',
  default: {
    reservationId: '',
    facilityId: '',
    areaId: '',
    sectionIdList: [],
    sectionNameList: [],
    adminFlag: false,
    groupId: '99999',
    reservedStartTime: '',
    reservedEndTime: '',
    usagePurpose: '',
    usageType: '',
    usageDetails: '',
    usageRange: 'reserved',
    personInCharge: '',
    email: '',
    tel: '',
    usageContents: 'amateur',
    numberOfTotalPeople: 0,
    numberOfElementaryMiddleSchoolStudents: 0,
    numberOfElementaryHighSchoolStudents: 0,
    numberOfOrdinaryPerson: 0,
    numberOfSpectator: 0,
    isCollectFee: false,
    isCommercialActivity: false,
    isElectricityUtilization: false,
    electricityUtilizationStartTime: '00:00',
    electricityUtilizationEndTime: '00:00',
    equipmentList: [],
    totalFee: 0,
    facilityFee: 0,
    equipmentFee: 0,
    paymentMethodsFlag: '01',
    selectedEquipmentTotal: 0,
    selectedEquipmentCount: 0,
    groupName: '',
    areaName: '',
    depositDate: ''
  }
});

export { ReservationState };

export type { Reservation, EquipmentListInput };
